import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { PAGE_CARDS } from '../../util/constants'
const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  card: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
});
const spacing = '16'
const HomePage = ({ classes, children }) =>
  (
    <Grid container className={classes.root} spacing={16}>
      <Grid item xs={12}>
        <Grid container className={classes.demo} justify="center" spacing={Number(spacing)}>
          {Object.values(PAGE_CARDS).map((card, key) => {
            console.log(card);
            const { title, image, content, action } = card;
            return (
              <Grid key={key} item >
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.media}
                    image={image}
                    title={title}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="headline" component="h2">
                      {title}
                    </Typography>
                    <Typography component="p">
                      {content}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    {action.map((a, key) => (
                      <Button key={key} component={Link} to={a.link} size="small" color="primary">
                        {a.title}
                      </Button>
                    ))}
                  </CardActions>
                </Card>
              </Grid>
            )
          }
          )}
        </Grid>
      </Grid>
    </Grid>
  );

HomePage.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.array
};

export default withStyles(styles)(HomePage);


// WEBPACK FOOTER //
// ./src/pages/home/index.js